<template>
    <button
        class="btn-challenge"
        @click="routeSelectUser">
        <svg class="btn-challenge__icon" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.342 11.9l2.16 3.6m0 0l2.88 2.16m-2.88-2.16l-2.16 2.16m-1.44 0l1.44 1.44m4.32-2.88l12.24-12.24V1.1h-2.88L4.782 13.34" stroke="#2779ED" stroke-width="2.16" stroke-linecap="round" stroke-linejoin="round"/><path d="M18.462 11.9l-2.16 3.6-2.88 2.16m6.48 0l-1.44 1.44zm-3.6-2.16l2.16 2.16zm-2.16.72L1.902 3.98V1.1h2.88l12.24 12.24" fill="#fff"/><path d="M18.462 11.9l-2.16 3.6m0 0l-2.88 2.16m2.88-2.16l2.16 2.16m1.44 0l-1.44 1.44m-4.32-2.88L1.902 3.98V1.1h2.88l12.24 12.24" stroke="#2779ED" stroke-width="2.16" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </button>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        methods: {
            routeSelectUser(){
                this.$router.push('/challenge/select-user');
            }
        }
    };
</script>

<style scoped src="@/css/components/btn-challenge.css"></style>